import React from "react";
import { Dialog, DialogTitle, Grid, CircularProgress } from "@material-ui/core";
import { BuilderAsset } from "../../entities/BuilderAsset";
import { OfflineBuilderAsset } from "../../entities/OfflineBuilderAsset";
import { BuilderAssetConflictItem } from "../offline/BuilderAssetConflictItem";

export interface ConflictedAsset {
	online: BuilderAsset;
	offline: OfflineBuilderAsset;
}

export interface ConflictStatus {
	total: number;
	current: number;
}

interface BuilderAssetConflictDialogProps {
	conflictedAssets: ConflictedAsset[];
	status: ConflictStatus;
	onConflictResolved: (id: string, result: BuilderAsset | null) => void;
}

export function BuilderAssetConflictDialog(props: BuilderAssetConflictDialogProps) {
	const { conflictedAssets, status } = props;
	return (
		<Dialog open={conflictedAssets.length > 0}>
			<DialogTitle>Which version do you want? {status.total > 1 ? `(${status.current} of ${status.total})` : undefined}</DialogTitle>
            {
                conflictedAssets.length > 0
                ?
                <BuilderAssetConflictItem conflictedAsset={conflictedAssets[0]} onConflictResolved={props.onConflictResolved} />
                :
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item>
                        <CircularProgress/>
                    </Grid>
                </Grid>
            }
		</Dialog>
	);
}

